import React from 'react'
import CountUp from 'react-countup';

const FunFact = (props) => {
    return (
        <section className="wpo-fun-fact-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-fun-fact-grids clearfix">
                            <div className="grid">
                                <div className="info">
                                    <h3><span><CountUp end={165} enableScrollSpy /></span>+</h3>
                                    <p>Empleados</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><span><CountUp end={38} enableScrollSpy /></span></h3>
                                    <p>Años de Experiencia</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><span><CountUp end={4500} enableScrollSpy /></span>+</h3>
                                    <p>Metros cuadrados de almacenaje</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><span><CountUp end={2400000} enableScrollSpy /></span>+</h3>
                                    <p>Litros Almacenaje</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;




